<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            v-model="query.state"
            clearable
            placeholder="请选择状态"
            @change="typeClick()"
          >
            <el-option
              v-for="item in statelist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="来源">
          <el-select
            v-model="query.origin"
            clearable
            placeholder="请选择来源"
            @change="typeClick()"
          >
            <el-option
              v-for="item in originlist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="跟进时间"
          label-width="80px"
          style="margin-left: 8px"
        >
          <el-date-picker
            v-model="query.daterange"
            @change="typeClick()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="地区">
          <el-cascader
            :options="areaList"
            v-model="query.selectedOptions"
            style="width: 100%"
            clearable
            filterable
            @change="typeClick()"
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <el-button type="success" @click="addClick()">新增</el-button>
            <el-button type="warning" @click="exportClick()">导出未签约</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表卡片 -->
    <div class="content">
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>客户列表</span>
        </div>
        <el-tabs v-model="query.type" @tab-click="getList()">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane
            v-for="item in typelist"
            :label="item.name"
            :key="item.id"
            :name="item.id.toString()"
          ></el-tab-pane>
        </el-tabs>
        <!-- 列表 -->
        <div>
          <el-table
            v-loading="loading"
            :data="tableData"
            ref="tableData"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column prop="nickName" label="客户昵称"></el-table-column>
            <el-table-column label="地区">
              <template slot-scope="scope"
                >{{ scope.row.province }} {{ scope.row.city }}</template
              >
            </el-table-column>
            <!-- <el-table-column label="性别">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.sex==true">男</el-tag>
                <el-tag type="success" v-else>女</el-tag>
              </template>
            </el-table-column> -->
            <el-table-column prop="wechat" label="微信"></el-table-column>
            <el-table-column prop="origin" label="来源"></el-table-column>
            <el-table-column prop="stateName" label="状态"></el-table-column>
            <el-table-column prop="summary" label="备注"></el-table-column>
            <el-table-column
              prop="followSummary"
              label="跟进备注"
            ></el-table-column>
            <el-table-column prop="lastTime" label="跟进时间"></el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button-group>
                  <el-tooltip content="编辑" placement="top">
                    <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-edit"
                      @click="editClick(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip content="客户跟进" placement="top">
                    <el-button
                      type="warning"
                      size="mini"
                      icon="el-icon-user"
                      @click="followClick(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip content="删除" placement="top">
                    <el-button
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      @click="deleteClick(scope.row)"
                    ></el-button>
                  </el-tooltip>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 弹框 -->
    <div>
      <el-dialog
        :title="form.id > 0 ? '编辑客户信息' : '添加客户信息'"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm(form)"
        >
          <el-form-item
            prop="nickName"
            label="昵称"
            :rules="[{ required: true, message: '不能为空' }]"
          >
            <el-input
              v-model="form.nickName"
              placeholder="请输入昵称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="性别"
            prop="sex"
            :rules="[{ required: true, message: '请输选择性别' }]"
          >
            <el-radio-group v-model="form.sex">
              <el-radio :label="true">男</el-radio>
              <el-radio :label="false">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="姓名" prop="realName">
                <el-input
                  v-model="form.realName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="mobile">
                <el-input
                  v-model="form.mobile"
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="微信" prop="wechat">
                <el-input
                  v-model="form.wechat"
                  placeholder="请输入微信号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="QQ" prop="qq">
                <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地区">
                <el-cascader
                  :options="areaList"
                  v-model="selectedOptions"
                  style="width: 100%"
                  clearable
                  filterable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="公司">
                <el-select
                  v-model="form.companyID"
                  clearable
                  filterable
                  placeholder="请选择关联公司"
                >
                  <el-option
                    v-for="item in companylist"
                    :label="item.fullName"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="类型"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <el-select
                  v-model="form.type"
                  clearable
                  placeholder="请选择类型"
                >
                  <el-option
                    v-for="item in typelist"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item
                label="来源"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <el-select
                  v-model="form.origin"
                  clearable
                  placeholder="请选择来源"
                >
                  <el-option
                    v-for="item in originlist"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="状态"
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <el-select
                  v-model="form.state"
                  clearable
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in statelist"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="备注" prop="summary">
            <el-input
              v-model="form.summary"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>

          <!-- 按钮 -->
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit"
              >提交</el-button
            >
            <el-button
              @click="
                dialogVisible = false;
                submiting = false;
              "
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      customid: "",
      query: {
        type: "0",
      },
      form: {},
      dialogVisible: false, //对话框显示
      submiting: false, //表单提交
      loading: false, //列表加载
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      typelist: [
        { id: 1, name: "客户" },
        { id: 2, name: "合作方" },
      ], //类型
      statelist: [], //状态
      originlist: [], //来源
      areaList: [], //地区
      selectedOptions: [],
      companylist: [], //关联公司
    };
  },
  methods: {
    // 来源
    getOriginList: function () {
      var _this = this;
      var link = url.getCrm("getorigin");
      $.get(link, {}, (data) => {
        _this.originlist = data;
      });
    },
    // 状态
    getStateList: function () {
      var _this = this;
      if (this.$route.params.state) {
        var state = this.$route.params.state;
        this.query.state = parseInt(state);
      } else {
        this.query.state = null;
      }
      var link = url.getCrm("getcustomerstate");
      $.get(link, {}, (data) => {
        _this.statelist = data;
      });
    },
    // 地区
    getAreaList: function () {
      var _this = this;
      var link = url.getCommon("getcity");
      $.get(link, {}, (data) => {
        _this.areaList = data;
      });
    },
    // 关联公司
    getCompanyList: function () {
      var _this = this;
      var link = url.getAccInfo("getall_commany");
      $.get(link, {}, (data) => {
        _this.companylist = data;
      });
    },
    // 列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      if (_this.query.selectedOptions) {
        params.province = _this.query.selectedOptions[0];
        params.city = _this.query.selectedOptions[1];
      } else {
        params.province = "";
        params.city = "";
      }
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.pageIndex;
      var link = url.getCrm("getlist_customer");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function () {
      this.pageIndex = 1;
      this.getList();
    },
    // 条件查询
    typeClick: function () {
      this.getList();
    },
    // 增加
    addClick: function () {
      this.dialogVisible = true;
      this.form = { sex: true };
      //地区选择重置
      this.selectedOptions = [];
    },
    // 编辑
    editClick: function (row) {
      this.dialogVisible = true;
      this.selectedOptions = [row.province, row.city];
      this.form = Object.assign({}, row);
    },
    //删除
    deleteClick: function (row) {
      var _this = this;
      var id = row.id;
      var link = url.getCrm("delete_customer");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.submiting = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getCrm("save_customer");
      var info = this.form;

      info.province = this.selectedOptions[0];
      info.city = this.selectedOptions[1];

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          _this.$message({
            message: "请完善必填信息",
            type: "warning",
          });
          return false;
        }
      });
    },
    // ——————————————————————————————其他方法
    // 分页方法
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.pageIndex1;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.pageIndex = val;
      this.getList();
    },
    //跟进跳转
    followClick: function (row) {
      this.$router.push({
        name: "followid",
        params: {
          id: row.id,
        },
      });
    },
        //导出exce
    exportClick(){
        var _this=this;
      var link=url.getCrm('toexcel');
           var params = this.query;
           var result = [];
           for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      link+='?'+result.join('&');
      window.open(link,'_blank');
    }
  },
  //监听路由变化
  watch: {
    //路由监听
    $route: function (to, from) {
      if (to.params.state != from.params.state) {
        this.getStateList();
        this.getList();
      }
    },
  },
  mounted() {
    // 来源
    this.getOriginList();
    // 状态
    this.getStateList();
    // 地区
    this.getAreaList();
    // 关联公司
    this.getCompanyList();
    //   列表
    this.getList();
  },
};
</script>